<script setup lang="ts">
/** Notice 386AG(2)(a) — Individual Controller */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-meta">THE COMPANIES ACT 1967</div>
      <div class="doc-lbl-title">NOTICE FOR CONTROLLERS — Section 386AG(2)(a)</div>
      <div class="doc-company" style="font-size:13px">(Individual Controller)</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Company Name</td>
          <td><CddVarField field-key="company_name" label="Company Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Notice Date</td>
          <td><CddVarField field-key="notice_date" label="Notice Date" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Notice Recipient Name</td>
          <td><CddVarField field-key="notice_recipient_name" label="Notice Recipient Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Reply-to Address</td>
          <td><CddVarField field-key="reply_to_address" label="Reply-to Address" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-sec-title">Particulars of Individual Controller</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Full Name</td>
          <td><CddVarField field-key="controller_full_name" label="Controller Full Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Aliases</td>
          <td><CddVarField field-key="controller_aliases" label="Aliases" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Residential Address</td>
          <td><CddVarField field-key="controller_residential_address" label="Residential Address" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Email</td>
          <td><CddVarField field-key="controller_email" label="Email" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Contact No.</td>
          <td><CddVarField field-key="controller_contact_no" label="Contact No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Nationality</td>
          <td><CddVarField field-key="controller_nationality" label="Nationality" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Identification No.</td>
          <td><CddVarField field-key="controller_identification_no" label="Identification No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Date of Birth</td>
          <td><CddVarField field-key="controller_date_of_birth" label="Date of Birth" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Date Became Controller</td>
          <td><CddVarField field-key="controller_became_date" label="Date Became Controller" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-sec-title">Notice Signer</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Notice Signer Name</td>
          <td><CddVarField field-key="notice_signer_name" label="Notice Signer Name" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
